/**
 * PATH: packages/ui/src/security/wordEmailCss.ts
 * FILE_ID: UI-SEC-WORD-CSS-001
 * PURPOSE: Keep Microsoft Word email stylesheets from being discarded.
 * ROLE IN ARCHITECTURE: Pre-pass for sanitizeEmailHtml.
 * MAIN EXPORTS: unwrapWordStyleComments
 * NON-RESPONSIBILITIES: Does not sanitize or scope CSS. sanitizeHtml does that.
 * NOTES FOR FUTURE AI: Only strip comment markers inside style blocks.
 */

/**
 * Word's "filtered" HTML hides the stylesheet in `<!-- -->` so old browsers
 * ignore it. The HTML parser treats that comment as the end of the style,
 * DOMPurify drops the block, and the message renders as plain text.
 *
 * Input: raw email HTML. Output: the same HTML with those markers removed
 * from each style block. Markers outside style are left alone.
 */
export function unwrapWordStyleComments(html: string): string {
  if (!html || !/<!--/.test(html)) return html
  return html.replace(/<style\b([^>]*)>([\s\S]*?)<\/style>/gi, (_full, attrs: string, css: string) => {
    const cleaned = css.replace(/<!--/g, '').replace(/-->/g, '')
    return `<style${attrs}>${cleaned}</style>`
  })
}
